<!-- 答辩前稿（含格式、错别字、AIGC、查重、智能评阅） -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 36.84">
    <title>答辩前稿</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="28.24" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="28.24" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M19.86,25.59H7.08a1,1,0,0,1-1-1h0V3a1,1,0,0,1,1-1H23.82a1,1,0,0,1,1,1,1,1,0,0,0,2,0A3,3,0,0,0,23.82,0H7.08A3,3,0,0,0,4.13,3h0V24.61a3,3,0,0,0,3,2.95H19.86a1,1,0,0,0,0-2Z"
        />
        <path
          class="cls-3"
          d="M17.91,6.89a1,1,0,0,0-1-1H9.05a1,1,0,0,0,0,2h7.88a1,1,0,0,0,1-1Zm-1,5.9a1,1,0,0,0-1-1H9.05a1,1,0,0,0,0,2h6.89a1,1,0,0,0,1-1ZM9.05,18.7a1,1,0,0,0,0,2H13a1,1,0,0,0,0-2Zm19.69-1.48h-2a63.34,63.34,0,0,0,2-6.39,4.92,4.92,0,1,0-9.84,0h0a46.14,46.14,0,0,0,2,6.39h-2a3,3,0,0,0-3,3h0v1a3,3,0,0,0,3,2.95h9.84a3,3,0,0,0,3-2.95h0v-1a3,3,0,0,0-3-3Zm-6.82-3c-.59-1.72-1.06-3.23-1.06-3.37a3,3,0,1,1,5.91,0v0c0,.19-1.61,4.87-2.16,6.39H23C22.78,16.6,22.34,15.4,21.92,14.2Zm7.8,7a1,1,0,0,1-1,1H18.9a1,1,0,0,1-1-1h0v-1a1,1,0,0,1,1-1h9.84a1,1,0,0,1,1,1h0v1Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 37.03">
    <title>答辩前稿</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="28.43" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="28.43" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M19.86,25.59H7.08a1,1,0,0,1-1-1h0V3a1,1,0,0,1,1-1H23.82a1,1,0,0,1,1,1,1,1,0,0,0,2,0A3,3,0,0,0,23.82,0H7.08A3,3,0,0,0,4.13,3h0V24.61a3,3,0,0,0,3,2.95H19.86a1,1,0,0,0,0-2Z"
        />
        <path
          class="cls-3"
          d="M17.91,6.89a1,1,0,0,0-1-1H9.05a1,1,0,0,0,0,2h7.88a1,1,0,0,0,1-1Zm-1,5.9a1,1,0,0,0-1-1H9.05a1,1,0,0,0,0,2h6.89a1,1,0,0,0,1-1ZM9.05,18.7a1,1,0,0,0,0,2H13a1,1,0,0,0,0-2Zm19.69-1.48h-2a63.34,63.34,0,0,0,2-6.39,4.92,4.92,0,1,0-9.84,0h0a46.14,46.14,0,0,0,2,6.39h-2a3,3,0,0,0-3,3h0v1a3,3,0,0,0,3,2.95h9.84a3,3,0,0,0,3-2.95h0v-1a3,3,0,0,0-3-3Zm-6.82-3c-.59-1.72-1.06-3.23-1.06-3.37a3,3,0,1,1,5.91,0v0c0,.19-1.61,4.87-2.16,6.39H23C22.78,16.6,22.34,15.4,21.92,14.2Zm7.8,7a1,1,0,0,1-1,1H18.9a1,1,0,0,1-1-1h0v-1a1,1,0,0,1,1-1h9.84a1,1,0,0,1,1,1h0v1Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 36.97">
    <title>答辩前稿</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="28.37" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="28.37" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M19.73,25.59H7a1,1,0,0,1-1-1H6V3A1,1,0,0,1,7,2H23.69a1,1,0,0,1,1,1,1,1,0,0,0,2,0A3,3,0,0,0,23.69,0H7A3,3,0,0,0,4,3H4V24.61a3,3,0,0,0,3,2.95H19.73a1,1,0,0,0,0-2Z"
        />
        <path
          class="cls-3"
          d="M17.78,6.89a1,1,0,0,0-1-1H8.93a1,1,0,1,0,0,2H16.8a1,1,0,0,0,1-1Zm-1,5.9a1,1,0,0,0-1-1H8.93a1,1,0,1,0,0,2h6.89a1,1,0,0,0,1-1ZM8.93,18.7a1,1,0,1,0,0,2h3.93a1,1,0,1,0,0-2Zm19.68-1.48h-2a65.3,65.3,0,0,0,2-6.39,4.92,4.92,0,1,0-9.84,0h0a46.14,46.14,0,0,0,2,6.39h-2a3,3,0,0,0-2.95,3h0v1a3,3,0,0,0,2.95,2.95h9.84a3,3,0,0,0,2.95-2.95h0v-1a3,3,0,0,0-2.95-3Zm-6.81-3c-.6-1.72-1.06-3.23-1.06-3.37a3,3,0,1,1,5.9,0v0c0,.19-1.6,4.87-2.16,6.39H22.9C22.66,16.6,22.22,15.4,21.8,14.2Zm7.8,7a1,1,0,0,1-1,1H18.77a1,1,0,0,1-1-1h0v-1a1,1,0,0,1,1-1h9.84a1,1,0,0,1,1,1h0v1Z"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: #25a98c;
    }
  }
</style>
